export default __webpack_public_path__ + "static/img-quantstamp-9ab7249a834451552f0e77e3dc4fc5d8.png";